// Before-After
//
// Drag-to-compare slider. The before photo is stacked over the after photo and
// clipped to the handle position, so both frames stay aligned. Pointer events
// cover mouse, touch and pen; the handle is a real button so the comparison is
// reachable from the keyboard. Multiple instances per page are supported.

(function () {
	'use strict';

	var STEP = 2;
	var PAGE_STEP = 10;
	var START = 50;

	function clamp( value ) {
		return Math.max( 0, Math.min( 100, value ) );
	}

	function init( slider ) {
		if ( ! slider || 'true' === slider.getAttribute( 'data-before-after-ready' ) ) {
			return;
		}

		var handle = slider.querySelector( '[data-before-after-handle]' );

		if ( ! handle ) {
			return;
		}

		slider.setAttribute( 'data-before-after-ready', 'true' );

		var position = START;
		var dragging = false;

		function setPosition( next ) {
			position = clamp( next );

			var rounded = Math.round( position );

			slider.style.setProperty( '--ba-pos', position + '%' );
			handle.setAttribute( 'aria-valuenow', rounded );
			handle.setAttribute( 'aria-valuetext', rounded + '% of the before photo shown' );
		}

		function positionFromEvent( event ) {
			var bounds = slider.getBoundingClientRect();

			if ( ! bounds.width ) {
				return position;
			}

			return ( ( event.clientX - bounds.left ) / bounds.width ) * 100;
		}

		function startDrag( event ) {
			dragging = true;
			slider.classList.add( 'is-dragging' );

			if ( slider.setPointerCapture && undefined !== event.pointerId ) {
				try {
					slider.setPointerCapture( event.pointerId );
				} catch ( error ) {
					// Capture is a nicety; dragging still works without it.
				}
			}

			setPosition( positionFromEvent( event ) );
			event.preventDefault();
		}

		function endDrag() {
			dragging = false;
			slider.classList.remove( 'is-dragging' );
		}

		slider.addEventListener( 'pointerdown', startDrag );

		slider.addEventListener( 'pointermove', function ( event ) {
			if ( dragging ) {
				setPosition( positionFromEvent( event ) );
			}
		} );

		slider.addEventListener( 'pointerup', endDrag );
		slider.addEventListener( 'pointercancel', endDrag );

		handle.addEventListener( 'keydown', function ( event ) {
			var next = null;

			switch ( event.key ) {
				case 'ArrowLeft':
				case 'ArrowDown':
					next = position - STEP;
					break;
				case 'ArrowRight':
				case 'ArrowUp':
					next = position + STEP;
					break;
				case 'PageDown':
					next = position - PAGE_STEP;
					break;
				case 'PageUp':
					next = position + PAGE_STEP;
					break;
				case 'Home':
					next = 0;
					break;
				case 'End':
					next = 100;
					break;
			}

			if ( null !== next ) {
				setPosition( next );
				event.preventDefault();
			}
		} );

		// The handle is only a drag target — a click should not do anything else.
		handle.addEventListener( 'click', function ( event ) {
			event.preventDefault();
		} );

		setPosition( START );
	}

	function initAll( scope ) {
		var root = scope || document;
		var sliders = root.querySelectorAll( '[data-before-after]' );

		Array.prototype.forEach.call( sliders, init );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', function () {
			initAll();
		} );
	} else {
		initAll();
	}

	// Gutenberg re-renders the block preview on every field change, which throws
	// away the initialized markup.
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=before-after', function ( $block ) {
			initAll( $block && $block[0] ? $block[0] : document );
		} );
	}
})();
